// src/guides/GuideDashboard.js
import React, { useEffect } from "react";
import { useAuth } from "../context/AuthContext";
import { useNavigate } from "react-router-dom";
import GuideProfile from "./GuideProfile";
import GuideBookings from "./GuideBookings";
import GuideEarnings from "./GuideEarnings";
import GuideAvailability from "./GuideAvailability";
import "../styles/GuideDashboard.css";
import appLogo from '../assets/app-icon.jpg';
const MOTIVATIONAL_MSG = `Being a guide is more than a job—it's about sharing stories, connecting cultures, and creating memories that last a lifetime. 
Thank you for guiding travelers on soulful journeys and inspiring curiosity with every step!`;

const GuideDashboard = () => {
    const { user, loggedIn, loading: authLoading } = useAuth();
    const navigate = useNavigate();

    useEffect(() => {
        if (!authLoading && !loggedIn) {
            navigate("/login");
        }
    }, [authLoading, loggedIn, navigate]);

    if (authLoading || !loggedIn) {
        return (
            <div className="guide-dashboard">
                <div className="guide-dashboard-loading">
                    <span role="status" aria-live="polite">
                        <span style={{ fontSize: "1.5em", marginRight: "8px" }}>⏳</span>
                        Loading dashboard...
                    </span>
                </div>
            </div>
        );
    }

    // Get name (fallback to 'Guide')
    const guideName = user?.name || "Guide";

    return (
        <div className="guide-dashboard">
            {/* Logo/Header */}
            <div style={{
                display: "flex",
                alignItems: "center",
                gap: "16px",
                marginBottom: "12px",
            }}>
                <img
                    src={appLogo} // Update with your logo path or replace with an <svg> if desired
                    alt="Soulful Yatra Logo"
                    style={{ width: 40, height: 40, borderRadius: 10, boxShadow: "0 1.5px 4.5px rgba(40,60,110,0.08)", background: "#f6f8fc" }}
                />
                <h1 style={{
                    fontFamily: "Inter, Roboto, Arial, sans-serif",
                    fontWeight: 800,
                    color: "#3746a7",
                    fontSize: "2rem",
                    margin: 0,
                    letterSpacing: "-1px"
                }}>
                    Soulful Yatra
                </h1>
            </div>
            {/* Welcome + Motivation */}
            <div style={{
                background: "#f8fafc",
                borderRadius: 12,
                padding: "18px 24px 10px 24px",
                boxShadow: "0 1px 6px rgba(60,70,120,0.07)",
                marginBottom: 32
            }}>
                <h2 style={{
                    margin: 0,
                    fontWeight: 700,
                    color: "#2bab56",
                    fontSize: "1.3rem",
                    letterSpacing: "-0.5px"
                }}>
                    Welcome, {guideName}! 👋
                </h2>
                <p style={{
                    marginTop: 12,
                    fontSize: "1.05rem",
                    color: "#42548d",
                    lineHeight: 1.7,
                    maxWidth: 600
                }}>
                    {MOTIVATIONAL_MSG}
                </p>
            </div>
            {/* Dashboard Sections */}

            <section aria-label="Your Bookings">
                <GuideBookings />
            </section>
            <section aria-label="Guide Earnings">
                <GuideEarnings />
            </section>
            <section aria-label="Availability">
                <GuideAvailability />
            </section>
            <section aria-label="Guide Profile">
                <GuideProfile />
            </section>
        </div>
    );
};

export default GuideDashboard;
